export enum financeEnum {
	TotalOnline = 1,
	TotalCash = 2,
	TotalPromos = 3,
	AddFund = 4,
	SubtractFund = 5,
	TotalCashBack = 6,
}
export const financeStatus: {
	name: string
	value: string
}[] = []
Object.keys(financeEnum).forEach((value: string) =>
	isNaN(+value)
		? financeStatus.push({
				name: value,
				value: financeEnum[value as any],
		  })
		: null
)
